import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IBackfillR2UploadsRequest } from './backfill-r2-uploads-request';
import type { IBackfillR2UploadsResponse } from './backfill-r2-uploads-response';
import { backfillR2UploadsResponseSchema } from './backfill-r2-uploads-response';

export async function backfillR2UploadsApi(
  body?: IBackfillR2UploadsRequest,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IBackfillR2UploadsResponse>> {
  return postRequest<IBackfillR2UploadsResponse>({
    path: '/sys/pipeline/backfill-r2-uploads/v1',
    body: body ?? {},
    schema: backfillR2UploadsResponseSchema,
    options,
  });
}
